export default __webpack_public_path__ + "static/media/work7.30717b90.jpeg";